import React, { memo, useCallback } from 'react';
import { Button } from 'shared/components/ui/Button';

export interface ErrorFallbackProps {
  error?: Error;
  resetErrorBoundary?: (...args: any[]) => void;
  source?: string;
  errorInfo?: React.ErrorInfo | null;
}

export const ErrorFallbackContent = memo(
  ({ error, resetErrorBoundary, source, errorInfo }: ErrorFallbackProps) => {
    const reloadPage = useCallback(() => {
      if (resetErrorBoundary) {
        resetErrorBoundary();
      }
      window.location.reload();
    }, [resetErrorBoundary]);

    return (
      <div className="error-boundary">
        <h1 className="error-boundary__title">
          Произошла ошибка, перезапустите приложение!
        </h1>
        {error && (
          <div
            style={{
              padding: '10px',
              backgroundColor: '#fee',
              border: '1px solid #f00',
              margin: '10px 0',
              borderRadius: '4px',
              fontSize: '12px',
              color: '#333',
              textAlign: 'left',
              overflowX: 'auto',
              whiteSpace: 'pre-wrap',
              maxHeight: '60vh',
              overflowY: 'auto',
            }}
          >
            <strong>Debug info:</strong>
            {source && (
              <>
                <br />
                <span style={{ color: '#d00' }}>
                  <strong>Source Component:</strong> {source}
                </span>
              </>
            )}
            <br />
            {error.message}
            <br />
            <br />
            <strong>Stack / Component Tree:</strong>
            <br />
            {errorInfo?.componentStack || error.stack}
          </div>
        )}
        <Button className="error-boundary__button" onClick={reloadPage}>
          Обновить
        </Button>
      </div>
    );
  },
);
